import * as T from '@/core/configs/types'
export const NoteDeleted = 'Deleted'
export const NoteNormal = 'Normal'
export const NoteImportant = 'Important'

export const NoteStatus = {
  NoteDeleted,
  NoteNormal,
  NoteImportant
}

export const Note = {
  content: {
    type: T.Text,
    key: 'content',
    label: 'Note Content'
  },
  status: {
    type: T.Select,
    key: 'status',
    label: 'Note Status',
    options: Object.values(NoteStatus)
  },
  createdDate: {
    type: T.Time,
    label: 'Created on',
    key: 'createdDate'
  },
  modifiedDate: {
    type: T.Time,
    label: 'Updated on',
    key: 'modifiedDate'
  }
}

export const FirstNoteForm = [
  {
    type: T.TextArea,
    span: -1,
    key: 'notes.0.content',
    label: 'Note',
    default: '新的留言信息',
    value: '新的留言信息',
    example: '新的留言信息',
    validators: []
  }
]

export const NoteForm = [
  {
    type: T.TextArea,
    span: -1,
    key: 'note',
    label: 'Note',
    default: '新的留言信息',
    value: '',
    example: '新的留言信息',
    validators: []
  }
]

export const NoteWrapUp = obj => {
  obj.notes = []
  if ('note' in obj && !!obj.note) {
    const note = {
      content: obj.note,
      status: NoteNormal,
      createdTime: new Date().toISOString()
    }
    obj.notes.push(note)
  }
  delete obj.note
  return obj
}

export const NewNoteForm = Object.fromEntries(
  [
    {
      ...Note.status,
      type: T.Select,
      span: 1,
      example: '',
      default: NoteNormal,
      value: NoteNormal,
      validators: []
    },
    {
      ...Note.content,
      type: T.TextArea,
      span: 1,
      example: '',
      default: '',
      value: '',
      minRows: 8,
      validators: [T.RequiredValidator]
    }
  ].map(one => [one.key, one])
)

export const ShipmentNote = {
  ...Note,
  containerNo: {
    type: T.Select,
    key: 'containerNo',
    label: 'Container No',
    options: []
  },
  address: {
    type: T.Select,
    key: 'address',
    label: 'Address',
    options: []
  }
}

export const ShipmentNoteForm = [
  {
    key: 'palletGroup',
    label: 'Pallet Group',
    span: 1,
    type: T.StockGroupSelect,
    example: '',
    default: '',
    value: '',
    validators: []
  },
  {
    ...Note.status,
    type: T.Select,
    span: 1,
    example: '',
    default: NoteNormal,
    value: NoteNormal,
    validators: []
  },
  {
    type: T.TextArea,
    span: -1,
    key: 'content',
    label: 'Note',
    default: 'New text message',
    value: '',
    example: 'New text message',
    validators: []
  }
]

export const ShipmentNoteWrapUp = obj => {
  obj.notes = []
  if ('note' in obj && !!obj.note) {
    const note = {
      content: obj.note,
      status: NoteNormal,
      createdTime: new Date().toISOString()
    }
    obj.notes.push(note)
  }
  delete obj.note
  return obj
}
